module.exports = __webpack_public_path__ + "img/load.fc41fb88.gif";